import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import MeasurementForms from './screens/file';
import './style/style.css'

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<MeasurementForms/>}/>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
  );
}

export default App;
